// Shared trigger styling for every filter-bar picker (`RelationshipFilter`,
// `FacetMultiSelectFilter`, and `PresetDateRangeFilter`'s own `className`
// prop) — a rounded, icon-led "pill" button rather than a boxed input with a
// floating label above it, matching the mockup's own filter row
// (`Global Map - Map tab.png`: "This Month ▾", "Sales ▾", "Subcontractor ▾",
// ...). Targets antd's internal `.ant-select-selector` node directly (the
// same `[&_...]:` Tailwind-arbitrary-variant technique already used
// elsewhere in this codebase, e.g. the empty-table scrollbar-gutter fix) —
// `!` modifiers because AntD's own generated selector class carries more
// specificity than an unmarked Tailwind utility.
// `text-xs` (12px, down from antd's own 14px default) so a longer label
// like "Project Manager (3)" fits its pill without truncating — paired with
// the wider `w-[190px]` each picker's own `className` now uses.
export const FILTER_PILL_CLASS =
  "[&_.ant-select-selector]:!rounded-full [&_.ant-select-selector]:!border-slate-200 [&_.ant-select-selector]:!bg-white [&_.ant-select-selector]:!h-9 [&_.ant-select-selector]:!items-center [&_.ant-select-selector]:!px-3 [&_.ant-select-selector]:!text-xs hover:[&_.ant-select-selector]:!border-slate-300"
